import { Text, SimpleGrid, Box } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import FormInput from 'components/fields/home/FormInput';

import { changeDwellingRatingInformation } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

import type { APIPersonalHomeApplicationForm } from 'types/api.types';

interface ElectricalSystemProps {
  dwelling: APIPersonalHomeApplicationForm['dwellings'][0];
  index: number;
}

const ElectricalSystem = ({ dwelling, index }: ElectricalSystemProps) => {
  const dispatch = useAppDispatch();

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(changeDwellingRatingInformation({ index, name, value }));
  };

  const ratingInfo = dwelling.rating_information;

  if (!ratingInfo) return null;

  return (
    <Box mb="20px">
      <Text fontWeight="medium" fontSize="md" mb="10px" color="gray.700">
        Electrical System
      </Text>
      <SimpleGrid columns={6} spacing="15px">
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Electrical Wiring Type"
          name="electrical_wiring_type"
          value={ratingInfo.electrical_wiring_type || ''}
          onChange={onInputChange}
          disabled
        />
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Electrical Panel Type"
          name="electrical_panel_type"
          value={ratingInfo.electrical_panel_type || ''}
          onChange={onInputChange}
          disabled
        />
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Service Amps"
          name="service_amps"
          value={ratingInfo.service_amps || ''}
          onChange={onInputChange}
          disabled
        />
      </SimpleGrid>

      {/* Electrical Upgrades */}
      <Text
        fontWeight="medium"
        fontSize="md"
        mt="15px"
        mb="10px"
        color="gray.700"
      >
        Electrical Upgrades
      </Text>
      <SimpleGrid columns={6} spacing="15px">
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Full Year Upgrade"
          name="upgrades_electrical_full_year"
          value={ratingInfo.upgrades.electrical.full_year || ''}
          onChange={(event: any) => {
            const { value } = event.target;
            dispatch(
              changeDwellingRatingInformation({
                index,
                name: 'upgrades',
                value: {
                  ...ratingInfo.upgrades,
                  electrical: {
                    ...ratingInfo.upgrades.electrical,
                    full_year: value,
                  },
                },
              }),
            );
          }}
          disabled
        />
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Partial Year Upgrade"
          name="upgrades_electrical_partial_year"
          value={ratingInfo.upgrades.electrical.partial_year || ''}
          onChange={(event: any) => {
            const { value } = event.target;
            dispatch(
              changeDwellingRatingInformation({
                index,
                name: 'upgrades',
                value: {
                  ...ratingInfo.upgrades,
                  electrical: {
                    ...ratingInfo.upgrades.electrical,
                    partial_year: value,
                  },
                },
              }),
            );
          }}
          disabled
        />
      </SimpleGrid>
    </Box>
  );
};

export default ElectricalSystem;
